/**
 * Service frontend para configuracion de canales notif del workflow (ADR-027.2, 0658b).
 *
 * Wrappers tipados sobre `request()` (helper que adjunta Authorization Bearer
 * automaticamente desde localStorage). Endpoints servidos por
 * `packages/backend/src/modules/platform/notify/notify-config.routes.ts`.
 */

import { request } from '../../shared/services/api';

export type CanalConfigurable = 'mail' | 'teams' | 'slack';

export interface NotifyChannelConfig {
  id: string;
  tenantId: string;
  mailHabilitado: boolean;
  mailFromEmail: string | null;
  tieneCredencialMail: boolean;
  teamsHabilitado: boolean;
  tieneCredencialTeams: boolean;
  slackHabilitado: boolean;
  tieneCredencialSlack: boolean;
  modoSandbox: boolean;
  creadoEn: string;
  actualizadoEn: string;
}

export interface NotifyChannelConfigPatch {
  mailHabilitado?: boolean;
  mailFromEmail?: string | null;
  teamsHabilitado?: boolean;
  slackHabilitado?: boolean;
  modoSandbox?: boolean;
}

/** GET /api/v1/admin/notify-config */
export async function obtenerConfigCanales(): Promise<NotifyChannelConfig> {
  const res = await request<{ data: NotifyChannelConfig }>('/admin/notify-config');
  return res.data;
}

/** PATCH /api/v1/admin/notify-config */
export async function actualizarConfigCanales(
  patch: NotifyChannelConfigPatch,
): Promise<NotifyChannelConfig> {
  const res = await request<{ data: NotifyChannelConfig }>('/admin/notify-config', {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return res.data;
}

/** PUT /api/v1/admin/notify-config/credenciales/:canal */
export async function setCredencialCanal(
  canal: CanalConfigurable,
  value: string,
): Promise<NotifyChannelConfig> {
  const res = await request<{ data: NotifyChannelConfig }>(
    `/admin/notify-config/credenciales/${canal}`,
    {
      method: 'PUT',
      body: JSON.stringify({ value }),
    },
  );
  return res.data;
}

/** DELETE /api/v1/admin/notify-config/credenciales/:canal */
export async function clearCredencialCanal(canal: CanalConfigurable): Promise<NotifyChannelConfig> {
  const res = await request<{ data: NotifyChannelConfig }>(
    `/admin/notify-config/credenciales/${canal}`,
    {
      method: 'DELETE',
    },
  );
  return res.data;
}
